export default __webpack_public_path__ + "static/media/taxefy_checkmark.35f59d43.png";